export default {"src":"/_next/static/media/tryggtgivande.7cabd002.svg","height":378,"width":709,"blurWidth":0,"blurHeight":0};